module.exports = __webpack_public_path__ + "img/heart (1).eae4e805.png";